import styled from 'styled-components';

export const EyeItalic = styled.i` 
  float: right;
  margin: -44px 27px 0 0;
  position: relative;
  
  &:hover {    
    color: #0f9972;
    cursor: pointer;
  }
`;